import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
})
export class HelpComponent implements OnInit {

  public isTextWhite: boolean = false;
  public whatsApp: string;

  constructor(private router: Router, private auth: AuthService) {
    this.whatsApp = environment.whatsAppUrl;
  }

  ngOnInit() {
    this.isTextWhite = (this.router.url.includes('login') || this.router.url.includes('contrasena')) ? true : false;
  }

  get userName() : string {
    if ('identity' in this.auth) {
      const {documentType, document} = this.auth.identity.userInfo;
      return `${documentType}:${document}:1;${this.auth.identity.username}`;
    }
    return '';
  }

  openWhatsapp() {
    (window as any).gtag('event', 'ayuda-sac', {
      event_category: 'con-login',
      event_label: this.userName,
    });
    window.open(this.whatsApp, '_newtab');
  }
}
